"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = exports.ImageWrapper = void 0;
const react_1 = __importDefault(require("react"));
const router_1 = require("@reach/router");
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const _utils_1 = require("@utils");
const _layouts_1 = require("@layouts");
const _theme_1 = require("@theme");
const _api_1 = __importDefault(require("@api"));
const _store_1 = __importDefault(require("@store")); // Component
var ProfileLayout = function ProfileLayout(_ref) {
    var children = _ref.children;
    var _useLocation = router_1.useLocation(), pathname = _useLocation.pathname;
    var isActive = function isActive(target) {
        return pathname === target || false;
    };
    var _useGlobal = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal2[1];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.user;
    }, function (actions) {
        return actions.signOut;
    }), user = _useGlobal3[0], signOut = _useGlobal3[1];
    var logout = function logout() {
        return _api_1.default('logout').then(function () {
            return signOut();
        });
    };
    var dateJoined = new Date(user === null || user === void 0 ? void 0 : user.createdAtTimestamp).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
    var currentPeriodEnds = (user === null || user === void 0 ? void 0 : user.recurringSubscription) && (user === null || user === void 0 ? void 0 : user.currentPeriodEndTimestamp) && (user === null || user === void 0 ? void 0 : user.currentPeriodEndTimestamp) > Date.now() ? new Date(user.currentPeriodEndTimestamp).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    }) : undefined;
    var headerImage;
    switch (user === null || user === void 0 ? void 0 : user.tier) {
        case 'bespoke':
            headerImage = '/images/accounts/bespokeHeader.png';
            break;
        case 'community':
            headerImage = '/images/accounts/communityHeader.png';
            break;
        default:
            headerImage = '/images/accounts/digitalHeader.png';
    }
    var upgrade = function upgrade() {
        setPanel('upgrade');
        setVisibleDropdown('account');
    };
    var links = [{
            label: 'Bookmarks',
            to: '/bookmarks',
            active: isActive('/bookmarks')
        }, {
            label: 'Account',
            to: '/account',
            active: isActive('/account')
        }, {
            label: 'Addresses',
            to: '/addresses',
            active: isActive('/addresses')
        }, {
            label: 'Wallet',
            to: '/wallet',
            active: isActive('/wallet')
        }, {
            label: 'Billing',
            to: '/billing',
            active: isActive('/billing')
        }, {
            label: 'Travel Profile',
            to: '/profile',
            active: isActive('/profile')
        }, {
            label: 'Sign out',
            onClick: function onClick() {
                return logout();
            }
        }];
    var quicklinksBar = /*#__PURE__*/ react_1.default.createElement(molecules_1.QuickLinksBar, {
        links: links
    });
    return /*#__PURE__*/ react_1.default.createElement(StyledLayout, {
        subHeaderContent: quicklinksBar,
        subHeaderMobileOnly: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Padding, null, /*#__PURE__*/ react_1.default.createElement(StyledMargin, null, user && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(Navigation, null, /*#__PURE__*/ react_1.default.createElement(Overflow, null, /*#__PURE__*/ react_1.default.createElement(NavSection, null, /*#__PURE__*/ react_1.default.createElement(exports.ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, {
        src: headerImage,
        objectFit: "cover"
    }))), /*#__PURE__*/ react_1.default.createElement(NavSection, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.ProfileSectionTitle, {
        shortMargin: true,
        labelTransform: true
    }, user.firstName, "\xA0", user.lastName), /*#__PURE__*/ react_1.default.createElement(Items, null, links.map(function (link, index) {
        return /*#__PURE__*/ react_1.default.createElement(Item, {
            active: link.active,
            onClick: link.onClick,
            key: "link_" + index
        }, link.to && /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
            to: link.to
        }, /*#__PURE__*/ react_1.default.createElement("span", null, link.label)), !link.to && /*#__PURE__*/ react_1.default.createElement("span", null, link.label));
    }))), /*#__PURE__*/ react_1.default.createElement(NavSection, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.ProfileSectionTitle, {
        shortMargin: true,
        labelTransform: true
    }, "Membership"), /*#__PURE__*/ react_1.default.createElement(DataRows, null, /*#__PURE__*/ react_1.default.createElement(DataRow, null, /*#__PURE__*/ react_1.default.createElement("dt", null, /*#__PURE__*/ react_1.default.createElement("span", null, "Joined")), /*#__PURE__*/ react_1.default.createElement("dd", null, /*#__PURE__*/ react_1.default.createElement("span", null, dateJoined))), currentPeriodEnds && /*#__PURE__*/ react_1.default.createElement(DataRow, null, /*#__PURE__*/ react_1.default.createElement("dt", null, /*#__PURE__*/ react_1.default.createElement("span", null, "Renews")), /*#__PURE__*/ react_1.default.createElement("dd", null, /*#__PURE__*/ react_1.default.createElement("span", null, currentPeriodEnds))), /*#__PURE__*/ react_1.default.createElement(DataRow, null, /*#__PURE__*/ react_1.default.createElement("dt", null, /*#__PURE__*/ react_1.default.createElement("span", null, "Tier")), /*#__PURE__*/ react_1.default.createElement("dd", null, /*#__PURE__*/ react_1.default.createElement("span", null, user.tier)))), /*#__PURE__*/ react_1.default.createElement(ButtonRow, null, user && user.tier !== 'bespoke' && /*#__PURE__*/ react_1.default.createElement("li", null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        size: "small",
        type: "black",
        display: "flex",
        onClick: function onClick() {
            return upgrade();
        }
    }, "Upgrade")), /*#__PURE__*/ react_1.default.createElement("li", null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        size: "small",
        type: "outline",
        display: "flex",
        to: "/contact"
    }, "Contact Us")))))), /*#__PURE__*/ react_1.default.createElement(Main, null, children)))));
}; // Styling
var StyledLayout = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(_layouts_1.Layout, props);
}).withConfig({
    displayName: "ProfileLayout__StyledLayout",
    componentId: "ws7rkq-0"
})(["background-color:", ";"], _theme_1.palette.snow);
var StyledMargin = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Margin, props);
}).withConfig({
    displayName: "ProfileLayout__StyledMargin",
    componentId: "ws7rkq-1"
})(["position:relative;display:flex;flex-direction:column;", "{flex-direction:row;align-items:flex-start;justify-content:space-between;}"], _utils_1.mediaQuery('laptop')); // Nav
var Navigation = styled_components_1.default.nav.withConfig({
    displayName: "ProfileLayout__Navigation",
    componentId: "ws7rkq-2"
})(["", "{display:none;}margin-bottom:32px;", "{margin-bottom:40px;}", "{position:sticky;top:127px;width:200px;margin-bottom:0;}", "{top:160px;width:240px;}"], _utils_1.mediaQuery('laptop', 'max'), _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Overflow = styled_components_1.default.div.withConfig({
    displayName: "ProfileLayout__Overflow",
    componentId: "ws7rkq-3"
})(["position:relative;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;width:100%;", "{flex-direction:column;justify-content:flex-start;}"], _utils_1.mediaQuery('laptop')); // Nav Section
var NavSection = styled_components_1.default.div.withConfig({
    displayName: "ProfileLayout__NavSection",
    componentId: "ws7rkq-4"
})(["width:100%;margin-bottom:32px;&:first-of-type{width:100%;margin-bottom:40px;}", "{width:calc(50% - 20px);margin-bottom:40px;}", "{width:100%;margin-bottom:48px !important;&:last-of-type{margin-bottom:0 !important;}}", "{margin-bottom:64px !important;&:last-of-type{margin-bottom:0 !important;}}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.ImageWrapper = styled_components_1.default.div.withConfig({
    displayName: "ProfileLayout__ImageWrapper",
    componentId: "ws7rkq-5"
})(["position:relative;height:140px;overflow:hidden;", "{height:91px;}", "{height:102px;}"], _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Items = styled_components_1.default.ul.withConfig({
    displayName: "ProfileLayout__Items",
    componentId: "ws7rkq-6"
})(["display:flex;flex-direction:column;", " ", "{", "}"], _theme_1.type.h2, _utils_1.mediaQuery('laptop'), _theme_1.type.label);
var Item = styled_components_1.default.li.withConfig({
    displayName: "ProfileLayout__Item",
    componentId: "ws7rkq-7"
})(["position:relative;overflow:hidden;cursor:pointer;color:", ";&::after{z-index:0;position:absolute;top:50%;bottom:50%;left:0;background-color:", ";width:100%;height:1px;margin:auto;transform:translate3d(", ",0,0);transition:transform 0.35s ease-in-out;content:'';pointer-events:none;}& span{z-index:1;position:relative;display:block;padding:4px 8px 4px 0;background-color:", ";width:fit-content;overflow:hidden;cursor:pointer;transition:color 0.25s ease-in-out;&::after{z-index:2;position:absolute;bottom:4px;left:0;background-color:", ";width:calc(100% - 8px);height:1px;transform:translate3d(-100%,0,0);transition:color 0.25s ease-in-out,transform 0.35s ease-in-out;content:'';pointer-events:none;}}", "{&:hover span{color:", ";&::after{transform:translate3d(0,0,0);}}}", "{& span{padding-top:8px;padding-bottom:8px;&::after{bottom:6px;}}}"], function (props) {
    return props.active ? _theme_1.palette.brown : _theme_1.palette.ink;
}, _utils_1.rgba(_theme_1.palette.brown, 0.24), function (props) {
    return props.active ? '0' : '-100%';
}, _theme_1.palette.snow, _theme_1.palette.brown, _utils_1.mediaQuery('tablet'), _theme_1.palette.brown, _utils_1.mediaQuery('laptop'));
var DataRows = styled_components_1.default.dl.withConfig({
    displayName: "ProfileLayout__DataRows",
    componentId: "ws7rkq-8"
})(["", " color:", ";& span{position:relative;display:block;padding:4px 0;width:fit-content;overflow:hidden;}& dt{padding-right:16px;}", "{", " & span{padding:8px 0;}}"], _theme_1.type.labelLarge, _theme_1.palette.rifle, _utils_1.mediaQuery('laptop'), _theme_1.type.label);
var DataRow = styled_components_1.default.div.withConfig({
    displayName: "ProfileLayout__DataRow",
    componentId: "ws7rkq-9"
})(["display:flex;justify-content:space-between;"]);
var ButtonRow = styled_components_1.default.ul.withConfig({
    displayName: "ProfileLayout__ButtonRow",
    componentId: "ws7rkq-10"
})(["padding-top:32px;& li{margin-bottom:16px;&:last-of-type{margin-bottom:0;}}"]); // Content
var Main = styled_components_1.default.main.withConfig({
    displayName: "ProfileLayout__Main",
    componentId: "ws7rkq-11"
})(["flex:1 1 auto;max-width:100%;", "{max-width:696px;padding:0 52px;}", "{max-width:896px;padding:0 108px;}"], _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.Grid = styled_components_1.default.div.withConfig({
    displayName: "ProfileLayout__Grid",
    componentId: "ws7rkq-12"
})(["position:relative;display:grid;grid-auto-rows:minmax(100px,auto);gap:40px;&.moodboard{gap:10px;}", "{grid-template-columns:repeat(2,1fr);gap:48px 32px;&.moodboard{grid-template-columns:repeat(3,1fr);gap:12px;}}", "{gap:56px 32px;&.moodboard{gap:14px;}}", "{gap:64px 32px;&.moodboard{gap:16px;}}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Types
exports.default = ProfileLayout;
